import moment from 'moment';

export async function logStat({
  endpoint = '/register',
  site,
  app,
  module: mod,
  date,
  time,
  useUTC = false,
  headers = {}
}) {
  const now = useUTC ? moment.utc() : moment();
  const body = {
    site: String(site),
    app: String(app),
    module: String(mod),
    date: date || now.format('YYYY-MM-DD'),
    time: time || now.format('HH:mm:ss'),
  };

  try {
        return await fetch(endpoint, {
            method: 'POST',
            keepalive: true,
            headers: { 'Content-Type': 'application/json', ...headers },
            body: JSON.stringify(body),
        });
    } catch (message) {
        return console.error(message);
    }
}
